import React, { useCallback, useEffect, useRef, useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import { AiOutlineClose } from "react-icons/ai";
import "../../App.css";
import "./dialog.css";

const TERMS_URL =
  "https://s3.ap-south-1.amazonaws.com/www.saveo.in/Curebay-Terms-and-Conditions.html";

const FRAME_WIDTH = 1212;
const PAGE_WIDTH = 1190.64;
const PAGE_OFFSET_X = 10.68;
const PAGE_OFFSET_Y = 10;

const getScrollbarWidth = () => {
  const probe = document.createElement("div");
  probe.style.cssText =
    "position:absolute;top:-9999px;width:100px;height:100px;overflow:scroll";
  document.body.appendChild(probe);
  const width = probe.offsetWidth - probe.clientWidth;
  probe.remove();
  return width;
};

const TermsModal = ({ show, onHide }) => {
  const [loading, setLoading] = useState(true);
  const [box, setBox] = useState({ width: 0, height: 0 });
  const [scrollbarWidth] = useState(getScrollbarWidth);
  const observerRef = useRef(null);

  useEffect(() => {
    if (show) setLoading(true);
  }, [show]);

  const bodyRef = useCallback((el) => {
    observerRef.current?.disconnect();
    observerRef.current = null;
    if (!el) return;
    const measure = () =>
      setBox({ width: el.clientWidth, height: el.clientHeight });
    measure();
    observerRef.current = new ResizeObserver(measure);
    observerRef.current.observe(el);
  }, []);

  const scale = box.width ? box.width / PAGE_WIDTH : 1;

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      aria-labelledby="terms-modal-title"
      className="terms_modal">
      <Modal.Header className="bg_primary terms_modal_header">
        <Modal.Title
          id="terms-modal-title"
          className="font_ubuntu color_white font_weight_md font_18">
          Terms of Use
        </Modal.Title>
        <button
          type="button"
          className="terms_modal_close"
          aria-label="Close"
          onClick={onHide}>
          <AiOutlineClose size="1.3rem" />
        </button>
      </Modal.Header>
      <Modal.Body className="terms_modal_body" ref={bodyRef}>
        {loading && (
          <div className="terms_modal_loader">
            <Spinner animation="border" className="color_primary" />
          </div>
        )}
        <iframe
          title="CureBay Terms of Use"
          src={TERMS_URL}
          className="terms_modal_frame"
          style={{
            width: FRAME_WIDTH + scrollbarWidth,
            height: box.height ? box.height / scale + PAGE_OFFSET_Y : "100%",
            transform: `scale(${scale}) translate(-${PAGE_OFFSET_X}px, -${PAGE_OFFSET_Y}px)`,
          }}
          onLoad={() => setLoading(false)}
        />
      </Modal.Body>
      <Modal.Footer className="terms_modal_footer">
        <Button
          className="bg_primary brdr_none font_ubuntu font_weight_md"
          onClick={onHide}>
          CLOSE
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TermsModal;
